<template>
  <div class="content1">
    <div class="operate">
      <el-button class="add" @click="addBadge">新增</el-button>
      <el-button class="add" @click="editBadge">修改</el-button>
      <el-button type="danger" @click="deleteBadge">删除</el-button>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="tableLoading"
        :height="windowHeight"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column prop="id" label="ID" align="center" min-width="60">
        </el-table-column>
        <el-table-column
          prop="iconId"
          label="图片（点亮）"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
             <el-image 
              style="width: 50px; height: 50px"
              v-if="row.iconId"
              :src="imgUrl + row.iconId"
              :preview-src-list="[imgUrl + row.iconId]">
            </el-image>
            <div v-else>/</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="iconId"
          label="图片（未点亮）"
          align="center"
          width="110"
        >
          <template slot-scope="{ row }">
            <el-image
              v-if="row.fileId"
              :src="imgUrl + row.fileId"
              :preview-src-list="[imgUrl + row.fileId]"
              style="width: 50px; height: 50px"
            />
            <div v-else>/</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="coverId"
          label="推送封面"
          align="center"
          width="100"
        >
          <template slot-scope="{ row }">
            <el-image
              v-if="row.coverId"
              :src="imgUrl + row.coverId"
              :preview-src-list="[imgUrl + row.coverId             
              ]"
              style="width: 50px; height: 50px"
            />
            <div v-else>/</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="medalName"
          label="徽章名称"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="medalTypeName"
          label="类别"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="point"
          label="积分"
          align="center"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <div v-if="row.point">{{ row.point }}</div>
            <div v-else>/</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="rTitleScope"
          label="职级"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="medalWhether"
          label="是否勋章"
          align="center"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <div v-if="row.medalWhether">
              {{
                row.medalWhether == 1 ? "是" : row.medalWhether == 2 ? "否" : ""
              }}
            </div>
            <div v-else>/</div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="unlockDuration"
          label="解锁时长"
          align="center"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <div v-if="row.unlockDuration">{{ row.unlockDuration }}</div>
            <div v-else>/</div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="rules"
          label="奖励计算规则"
          align="center"
          min-width="100"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <div v-if="row.rules">{{ row.rules }}</div>
            <div v-else>/</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="coefficient"
          label="时长系数"
          align="center"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <div v-if="row.coefficient">{{ row.coefficient }}</div>
            <div v-else>/</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="duration"
          label="设定时长"
          align="center"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <div v-if="row.duration">{{ row.duration }}</div>
            <div v-else>/</div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="unlockDescribe"
          label="解锁条件"
          align="center"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <div v-if="row.medalWhether == 2">/</div>
            <div v-else style="color: #2d75e3" @click="handleCondition(row)">
              查看
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remarks"
          label="说明"
          align="center"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <div v-if="row.medalWhether == 2">/</div>
            <div v-else style="color: #2d75e3" @click="handleExplain(row)">
              查看
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="pushLanguage"
          label="推送语"
          align="center"
          min-width="80"
        >
          <template slot-scope="{ row }">
            <div v-if="row.medalWhether == 2">/</div>
            <div v-else style="color: #2d75e3" @click="handlePushLanguage(row)">
              查看
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateUserName"
          label="更新人"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="update_time"
          label="更新时间"
          align="center"
          min-width="160"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="`徽章类别${title}`"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <div class="dialog_content">
        <el-form
          :model="form"
          label-width="80px"
          class="demo-form-inline"
          :rules="rules"
          ref="ruleForm"
        >
          <el-row style="flex-wrap: wrap" type="flex" :gutter="20">
            <el-col :span="12">
              <el-form-item label="所属类别" prop="medalTypeId">
                <el-select
                  v-model="form.medalTypeId"
                  placeholder="请选择所属类别"
                  style="width: 100%"
                  @change="handleMedalTypeId"
                >
                  <el-option
                    v-for="item in optionsType"
                    :key="item.id"
                    :label="item.medalTypeName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="isShowYear == 4">
              <el-form-item label="是否勋章" prop="medalWhether">
                <el-select
                  v-model="form.medalWhether"
                  placeholder="请选择是否勋章"
                  style="width: 100%"
                  @change="handleIsShowMedal"
                  disabled
                >
                  <el-option
                    v-for="item in optionsShowMedal"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.medalWhether != 2">
              <el-form-item label="徽章名称" prop="medalName">
                <el-input
                  v-model="form.medalName"
                  placeholder="请输入徽章名称"
                  @input="changeMedalName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-else>
              <el-form-item label="徽章名称" prop="medalName">
                <el-select
                  v-model="form.medalName"
                  placeholder="请选择是否勋章"
                  style="width: 100%"
                  @change="changeMedalName"
                >
                  <el-option
                    v-for="item in optionsMedalName"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.medalWhether == 2">
              <el-form-item
                label="奖励计算规则"
                prop="rules6"
                label-width="110px"
              >
                <el-select
                  v-model="form.rules6"
                  placeholder="请选择奖励计算规则"
                  style="width: 100%"
                  @change="handleCalculateRule"
                  disabled
                >
                  <el-option
                    v-for="item in optionsCalculateRule"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" >
              <el-form-item label="积分" prop="point">
                <el-input
                  type="number"
                  min="0"
                  v-model="form.point"
                  @input="changePoint"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.medalTypeId == 115">
              <el-form-item label="职级" prop="rTitleScope">
                <el-select
                  v-model="form.rTitleScope"
                  placeholder="请选择职级"
                  clearable
                  filterable
                  multiple
                  collapse-tags
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in optionsRank"
                    :key="item.id"
                    :label="item.title"
                    :value="item.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="isShowYear == 3">
              <el-form-item label="奖励年份" prop="companyAge">
                <el-select
                  v-model="form.companyAge"
                  placeholder="请选择奖励年份"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in optionsYear"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="isShowYear == 4 && form.medalWhether == 1">
              <el-form-item label="解锁时长" prop="unlockDuration">
                <el-input
                  v-model="form.unlockDuration"
                  type="number"
                  min="0"
                  placeholder="请输入解锁时长"
                  @input="changeUnlockDuration"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              v-if="
                isShowYear == 4 &&
                form.medalWhether == 2 &&
                (form.rules6 == '按献血量' ||
                  form.rules6 == '按捐款/捐物价值' ||
                  form.rules6 == '')
              "
            >
              <el-form-item label="时长系数" prop="coefficient">
                <el-input
                  v-model="form.coefficient"
                  type="number"
                  min="0"
                  placeholder="请输入时长系数"
                  @input="changeDurationCoefficient"
                ></el-input>
                <div class="form_hint">献血量*献血时长系数=时长</div>
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              v-if="
                isShowYear == 4 &&
                form.rules6 == '按活动' &&
                form.medalWhether == 2
              "
            >
              <el-form-item label="设定时长" prop="duration">
                <el-input
                  v-model="form.duration"
                  type="number"
                  min="0"
                  placeholder="请输入设定时长"
                  @input="changeSetDuration"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24" v-if="form.medalWhether != 2">
              <div style="display: flex; align-items: center">
                <el-form-item label="徽章图标" prop="iconId">
                  <el-upload
                    :action="`${upload}/file/upload`"
                    list-type="picture-card"
                    :on-success="handleBeforeImage"
                    :on-remove="handleRemove"
                    :on-preview="previewBeforeImage"
                    :limit="1"
                    :file-list="beforeImageList"
                    accept=".jpg,.jpeg,.png"
                    :class="{ hide: hideUpload }"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <div style="text-align: center; margin-top: 10px">点亮</div>
                </el-form-item>
                <el-form-item prop="fileId">
                  <el-upload
                    :action="`${upload}/file/upload`"
                    list-type="picture-card"
                    :on-success="handleBeforeImage1"
                    :on-remove="handleRemove1"
                    :on-preview="previewBeforeImage1"
                    :limit="1"
                    :file-list="beforeImageList1"
                    accept=".jpg,.jpeg,.png"
                    :class="{ hide: hideUpload1 }"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <div style="text-align: center; margin-top: 10px">未点亮</div>
                </el-form-item>
                <el-form-item prop="coverId">
                  <el-upload
                    :action="`${upload}/file/upload`"
                    list-type="picture-card"
                    :on-success="handleBeforeImage2"
                    :on-remove="handleRemove2"
                    :on-preview="previewBeforeImage2"
                    :limit="1"
                    :file-list="beforeImageList2"
                    accept=".jpg,.jpeg,.png"
                    :class="{ hide: hideUpload2 }"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <div style="text-align: center; margin-top: 10px">
                    推送封面
                  </div>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12" v-if="form.medalWhether != 2">
              <el-form-item label="解锁条件" prop="unlockDescribe">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入解锁条件"
                  v-model="form.unlockDescribe"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.medalWhether != 2">
              <el-form-item label="说明" prop="remarks">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入说明"
                  v-model="form.remarks"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="form.medalWhether != 2">
              <el-form-item label="推送语" prop="pushLanguage">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入推送语"
                  v-model="form.pushLanguage"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button class="add" @click="confirmSubmit" :disabled="isBtnDisabled"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="deleteVisible" width="30%">
      <span>你确定要删除你选中的这条记录吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button class="add" @click="confirmDetele" :disabled="isBtnDisabled"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleImg">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleImg1">
      <img width="100%" :src="dialogImageUrl1" alt="" />
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleImg2">
      <img width="100%" :src="dialogImageUrl2" alt="" />
    </el-dialog>
    <el-dialog :visible.sync="visibleUnlockDescribe" title="解锁条件">
      <el-input type="textarea" :rows="6" readonly v-model="unlockDescribe">
      </el-input>
    </el-dialog>
    <el-dialog :visible.sync="visibleRemarks" title="说明">
      <el-input type="textarea" :rows="8" readonly v-model="remarks">
      </el-input>
    </el-dialog>
    <el-dialog :visible.sync="visiblePushLanguage" title="推送语">
      <el-input type="textarea" :rows="8" readonly v-model="pushLanguage">
      </el-input>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/apis/medal";
export default {
  name: "badgeMaintain",
  data() {
    return {
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      tableData: [],
      multipleSelection: [],
      tableLoading: false,
      windowHeight: 350,
      dialogVisible: false,
      form: {
        medalTypeId: "",
        medalName: "",
        point: null,
        iconId: "",
        fileId: "",
        coverId: "",
        weight: null,
        unlockDescribe: "",
        remarks: "",
        pushLanguage: "",
        rules6: "",
        coefficient: "",
        medalWhether: 1,
        rTitleScope: []
      },
      rules: {
        medalTypeId: [
          { required: true, message: "请选择所属类别", trigger: "change" }
        ],
        companyAge: [
          { required: true, message: "请选择奖励年份", trigger: "change" }
        ],
        medalName: [
          {
            required: true,
            trigger: "blur",
            validator: this.validatePass
          }
        ],
        point: [
          { required: true, trigger: "blur", validator: this.validatePoint }
        ],
        iconId: [
          { required: true, trigger: "change", validator: this.validateIconId }
        ],
        fileId: [{ required: true, validator: this.validateFileId }],
        coverId: [{ required: true, validator: this.validateCoverId }],
        rules6: [
          {
            required: true,
            trigger: "change",
            validator: this.validateCalculateRule
          }
        ],
        coefficient: [
          {
            required: true,
            trigger: "blur",
            validator: this.validateDurationCoefficient
          }
        ],
        medalWhether: [
          {
            required: true,
            trigger: "change",
            validator: this.validateIsShowMedal
          }
        ],
        duration: [
          {
            required: true,
            trigger: "blur",
            validator: this.validateSetDuration
          }
        ],
        unlockDuration: [
          {
            required: true,
            trigger: "blur",
            validator: this.validateUnlockDuration
          }
        ]
      },
      title: "新增",
      deleteVisible: false,
      itemId: "",
      optionsType: [],
      optionsStatus: [
        {
          value: "",
          label: "全部"
        },
        {
          value: 1,
          label: "是"
        },
        {
          value: 2,
          label: "否"
        }
      ],
      optionsStatusList: [
        {
          value: 1,
          label: "是"
        },
        {
          value: 2,
          label: "否"
        }
      ],
      beforeImageList: [],
      beforeImageList1: [],
      beforeImageList2: [],
      dialogImageUrl: "",
      dialogImageUrl1: "",
      dialogImageUrl2: "",
      dialogVisibleImg: false,
      dialogVisibleImg1: false,
      dialogVisibleImg2: false,
      upload: "",
      hideUpload: false,
      hideUpload1: false,
      hideUpload2: false,
      imgUrl: "",
      medalTypeList: [],
      visibleUnlockDescribe: false,
      visibleRemarks: false,
      visiblePushLanguage: false,
      unlockDescribe: "",
      remarks: "",
      pushLanguage: "",
      optionsYear: [
        {
          label: "五周年",
          value: 5
        },
        {
          label: "十周年",
          value: 10
        },
        {
          label: "十五周年",
          value: 15
        },
        {
          label: "二十周年",
          value: 20
        }
      ],
      isShowYear: false,
      isShowRecord: 1,
      optionsBadgeType: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "1",
          label: "已发布"
        },
        {
          value: "2",
          label: "已过期"
        },
        {
          value: "3",
          label: "未发布"
        }
      ],
      isBtnDisabled: false,
      optionsCalculateRule: [
        {
          label: "按献血量",
          value: "按献血量"
        },
        {
          label: "按捐款/捐物价值",
          value: "按捐款/捐物价值"
        },
        {
          label: "按活动",
          value: "按活动"
        },
        {
          label: "按时长",
          value: "按时长"
        }
      ],
      optionsShowMedal: [
        {
          value: 1,
          label: "是"
        },
        {
          value: 2,
          label: "否"
        }
      ],
      optionsMedalName: [
        {
          value: "无偿献血",
          label: "无偿献血"
        },
        {
          value: "公益捐款",
          label: "公益捐款"
        },
        {
          value: "公益捐赠",
          label: "公益捐赠"
        },
        {
          value: "指尖公益",
          label: "指尖公益"
        },
        {
          value: "志愿服务",
          label: "志愿服务"
        },
        {
          value: "团体公益时长",
          label: "团体公益时长"
        }
      ],
      optionsRank: []
    };
  },
  mounted() {
    this.upload = api.upload;
    this.imgUrl = api.imgUrl;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryTypeList();
    this.queryData();
    this.getRankList();
  },
  // 销毁
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    // 获取职级列表
    getRankList() {
      api
        .getPositionLevel({ type: "EmpRank" })
        .then((res) => {
          if (res.code == 200) {
            this.optionsRank = res.data || [];
          }
        })
        .catch((err) => {
          console.error("获取职级列表失败:", err);
        });
    },
handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 280;
      });
    },
    //校验徽章名称
    validatePass(rule, value, callback) {
      console.log(1111, this.form.medalName);

      if (!this.form.medalName) {
        callback(new Error("请输入徽章名称"));
      } else {
        if (this.title == "新增") {
          const typeName = this.medalTypeList.filter(
            item => item.medalName === this.form.medalName
          );
          if (typeName.length > 0) {
            callback(new Error("徽章名称不能重复"));
          } else {
            callback();
          }
        } else {
          const typeName = this.medalTypeList.filter(
            item => item.id != this.itemId
          );
          const typeNameList = typeName.filter(
            item => item.medalName === this.form.medalName
          );

          if (typeNameList.length > 0) {
            callback(new Error("徽章名称不能重复"));
          } else {
            callback();
          }
        }
      }
    },
    //校验计算规则
    validateCalculateRule(rule, value, callback) {
      console.log(value, "value");
      console.log(this.form.rules6, "this.form.rules6");

      if (!this.form.rules6) {
        callback(new Error("请选择奖励计算规则"));
      } else {
        callback();
      }
    },
    //校验是否勋章
    validateIsShowMedal(rule, value, callback) {
      if (!this.form.medalWhether) {
        callback(new Error("请选择是否勋章"));
      } else {
        callback();
      }
    },
    //校验分值
    validatePoint(rule, value, callback) {
      if (!this.form.point && this.form.point !== 0) {
        callback(new Error("请输入分值"));
      } else {
        this.form.point = this.form.point.toString();
        var reg = /^\d{1,9}$/;
        if (!this.form.point.match(reg)) {
          this.form.point = null;
          callback(new Error("分值请输入非负整数"));
        } else {
          callback();
        }
      }
    },
    //校验解锁时长
    validateUnlockDuration(rule, value, callback) {
      if (!this.form.unlockDuration) {
        callback(new Error("请输入解锁时长"));
      } else {
        if (!(this.form.unlockDuration > 0)) {
          this.form.unlockDuration = null;

          callback(new Error("解锁时长请输入正数"));
          this.$forceUpdate();
        } else {
          callback();
        }
      }
    },
    //校验时长系数
    validateDurationCoefficient(rule, value, callback) {
      if (!this.form.coefficient) {
        callback(new Error("请输入时长系数"));
      } else {
        if (!(this.form.coefficient > 0)) {
          this.form.coefficient = null;

          callback(new Error("时长系数请输入正数"));
          this.$forceUpdate();
        } else {
          callback();
        }
      }
    },
    //校验设定时长
    validateSetDuration(rule, value, callback) {
      if (!this.form.duration) {
        callback(new Error("请输入设定时长"));
      } else {
        if (!(this.form.duration > 0)) {
          this.form.duration = null;
          callback(new Error("设定时长请输入正数"));
          this.$forceUpdate();
        } else {
          callback();
        }
      }
    },

  //校验徽章图标点亮
    validateIconId(rule, value, callback) {
      if (!this.form.iconId) {
        callback(new Error("请选择点亮图"));
      } else {
        callback();
      }
    },
    //校验徽章图标未点亮
    validateFileId(rule, value, callback) {
      if (!this.form.fileId) {
        callback(new Error("请选择未点亮图"));
      } else {
        callback();
      }
    },
    //校验推送封面
    validateCoverId(rule, value, callback) {
      if (!this.form.coverId) {
        callback(new Error("请选择推送封面"));
      } else {
        callback();
      }
    },
    queryParams() {
      this.queryData();
    },
    //重置查询条件
    handleReset() {
      this.query = {
        medalName: "",
        medalTypeId: "",
        status: ""
      };
      this.queryData();
    },
    //导出
    handleExport() {
      this.$refs.exportDialog.dialogVisible = true;
    },
    // 选择table
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.queryData();
    },
    //取消新增编辑弹框
    handleClose() {
      this.isShowYear = null;
      this.dialogVisible = false;
      this.itemId = "";
      this.beforeImageList = [];
      this.beforeImageList1 = [];
      this.beforeImageList2 = [];
      this.$refs.ruleForm?.resetFields();
    },
    // 显示 新增
    addBadge() {
      this.title = "新增";
      this.form = {};
      this.form.medalWhether = 1;
      this.hideUpload = false;
      this.hideUpload1 = false;
      this.hideUpload2 = false;
      this.dialogVisible = true;
      this.itemId = "";
      this.isShowYear = null;
      this.beforeImageList = [];
      this.beforeImageList1 = [];
      this.beforeImageList2 = [];
      this.$refs.ruleForm?.resetFields();
    },
    //显示 编辑
    editBadge() {
      if (this.multipleSelection.length == 1) {
        this.form = {
          medalTypeId: this.multipleSelection[0].medalTypeId,
          status: this.multipleSelection[0].status
            ? this.multipleSelection[0].status
            : 1,
          medalName: this.multipleSelection[0].medalName,
          point: this.multipleSelection[0].point,
          iconId: this.multipleSelection[0].iconId,
          fileId: this.multipleSelection[0].fileId,
          coverId: this.multipleSelection[0].coverId,
          weight: this.multipleSelection[0].weight,
          unlockDescribe: this.multipleSelection[0].unlockDescribe,
          remarks: this.multipleSelection[0].remarks,
          pushLanguage: this.multipleSelection[0].pushLanguage,
          // medalWhether: this.multipleSelection[0].medalWhether,
          medalWhether:1,
          unlockDuration: this.multipleSelection[0].unlockDuration,
          rules6: this.multipleSelection[0].rules,
          coefficient: this.multipleSelection[0].coefficient,
          duration: this.multipleSelection[0].duration,
          rTitleScope: (this.multipleSelection[0].rTitleScope ? this.multipleSelection[0].rTitleScope.split(',') : [])
        };
        if (this.multipleSelection[0].companyAge) {
          this.form.companyAge = this.multipleSelection[0].companyAge;
        }
        this.itemId = this.multipleSelection[0].id;
        if (this.multipleSelection[0].iconId) {
          this.beforeImageList = [
            {
              url: api.imgUrl + this.multipleSelection[0].iconId,
              isImage: true
            }
          ];
          this.hideUpload = true;
        } else {
          this.hideUpload = false;
        }
        if (this.multipleSelection[0].fileId) {
          this.beforeImageList1 = [
            {
              url: api.imgUrl + this.multipleSelection[0].fileId,
              isImage: true
            }
          ];
          this.hideUpload1 = true;
        } else {
          this.hideUpload1 = false;
        }
        if (this.multipleSelection[0].coverId) {
          this.beforeImageList2 = [
            {
              url: api.imgUrl + this.multipleSelection[0].coverId,
              isImage: true
            }
          ];
          this.hideUpload2 = true;
        } else {
          this.hideUpload2 = false;
        }

        this.title = "编辑";
        this.handleMedalTypeId();
      } else if (this.multipleSelection.length > 1) {
        return this.$message({
          message: "请选择一条内容进行编辑",
          type: "warning"
        });
      } else {
        return this.$message({
          message: "请选择需要编辑的内容",
          type: "warning"
        });
      }
      this.dialogVisible = true;
    },
    // 确认新增 编辑
    confirmSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.title == "编辑") {
            this.form.id = this.multipleSelection[0].id;
          }
          let json = {};
          if (this.form.medalWhether == 1 || !this.form.medalWhether) {
            json = {
              medalTypeId: this.form.medalTypeId,
              medalWhether:
                this.form.medalTypeId == 4 ? this.form.medalWhether : null,
              medalName: this.form.medalName,

              point: this.form.point,
              companyAge: this.form.companyAge,
              unlockDuration: this.form.unlockDuration,
              iconId: this.form.iconId,
              fileId: this.form.fileId,
              coverId: this.form.coverId,
              unlockDescribe: this.form.unlockDescribe,
              remarks: this.form.remarks,
              pushLanguage: this.form.pushLanguage,
              id: this.form.id,
              rTitleScope: this.form.rTitleScope
            };
          } else {
            json = {
              medalTypeId: this.form.medalTypeId,
              medalWhether: this.form.medalWhether,
              medalName: this.form.medalName,
              rules: this.form.rules6,
              coefficient: this.form.coefficient,
              duration: this.form.duration,
              id: this.form.id,
              rTitleScope: this.form.rTitleScope
            };
          }
          json.rTitleScope = json.rTitleScope.join(',');
          this.isBtnDisabled = true;
          api
            .addOrUpdateMedal(json)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  message: this.title + "成功",
                  type: "success"
                });
                this.itemId = "";
                this.isBtnDisabled = false;
                this.dialogVisible = false;
                this.beforeImageList = [];
                this.beforeImageList1 = [];
                this.beforeImageList2 = [];
                this.queryData();
              }
            })
            .catch(() => {
              this.isBtnDisabled = false;
            });
        } else {
          return false;
        }
      });
    },
    // 显示 删除弹框
    deleteBadge() {
      if (this.multipleSelection.length == 1) {
        this.deleteVisible = true;
      } else if (this.multipleSelection.length > 1) {
        return this.$message({
          message: "请选择一条内容进行删除",
          type: "warning"
        });
      } else {
        return this.$message({
          message: "请选择需要删除的内容",
          type: "warning"
        });
      }
    },
    //确认删除
    confirmDetele() {
      this.isBtnDisabled = true;
      api
        .deleteMedal({ id: this.multipleSelection[0].id })
        .then(res => {
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.isBtnDisabled = false;
            this.deleteVisible = false;
            this.queryData();
          }
        })
        .catch(() => {
          this.isBtnDisabled = false;
        });
    },
    //徽章类别列表
    queryTypeList() {
      api.queryDataMedalType({ page: 1, pageSize: 500 }).then(res => {
        if (res.code == 200) {
          this.optionsType = res.data;
        }
      });
    },
    // 查询 列表
    queryData() {
      const json = {
        ...this.pageData
        // ...this.query
      };
      this.tableLoading = true;
      api
        .queryByPageList(json)
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.total;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    //上传
    handleBeforeImage(file) {
      this.hideUpload = true;
      this.form.iconId = file.id;
      this.$refs.ruleForm.clearValidate("iconId");
    },
    //删除
    handleRemove() {
      this.form.iconId = "";
      this.hideUpload = false;
    },
    // 图片放大预览
    previewBeforeImage(file) {
      this.dialogImageUrl = file.response
        ? api.imgUrl + file.response.id
        : file.url;
      // this.dialogImageUrl = file.url;
      this.dialogVisibleImg = true;
    },
    handleBeforeImage1(file) {
      this.hideUpload1 = true;
      this.form.fileId = file.id;
      this.$refs.ruleForm.clearValidate("fileId");
    },
    //删除
    handleRemove1() {
      this.form.fileId = "";
      this.hideUpload1 = false;
    },
    // 图片放大预览
    previewBeforeImage1(file) {
      this.dialogImageUrl1 = file.response
        ? api.imgUrl + file.response.id
        : file.url;
      // this.dialogImageUrl1 = file.url;
      this.dialogVisibleImg1 = true;
    },
    handleBeforeImage2(file) {
      this.hideUpload2 = true;
      this.form.coverId = file.id;
      this.$refs.ruleForm.clearValidate("coverId");
    },
    //删除
    handleRemove2() {
      this.form.coverId = "";
      this.hideUpload2 = false;
    },
    // 图片放大预览
    previewBeforeImage2(file) {
      this.dialogImageUrl2 = file.response
        ? api.imgUrl + file.response.id
        : file.url;
      // this.dialogImageUrl1 = file.url;
      this.dialogVisibleImg2 = true;
    },
    // 改变所属类别
    handleMedalTypeId() {
      const info = this.optionsType.filter(
        item => item.id == this.form.medalTypeId
      );
      this.isShowYear = info[0]?.cardType;
      // this.form.rules6 = "";
      api
        .queryByPageList({
          page: 1,
          pageSize: 500,
          medalTypeId: this.form.medalTypeId
        })
        .then(res => {
          if (res.code == 200) {
            this.medalTypeList = res.data;
          }
        });
    },
    //查看解锁条件
    handleCondition(row) {
      this.unlockDescribe = row.unlockDescribe;
      this.visibleUnlockDescribe = true;
    },
    //查看说明
    handleExplain(row) {
      this.remarks = row.remarks;
      this.visibleRemarks = true;
    },
    //查看推送语
    handlePushLanguage(row) {
      this.pushLanguage = row.pushLanguage;
      this.visiblePushLanguage = true;
    },
    //改变计算规则
    handleCalculateRule() {
      // this.form.point = "";
      this.form.coefficient = "";
      this.$forceUpdate();
    },
    //改变是否勋章
    handleIsShowMedal() {
      this.form.medalName = "";
      this.form.coefficient = null;
      this.form.rules6 = null;
      this.form.duration = null;
      this.$forceUpdate();
    },
    //改变勋章名称
    changeMedalName(value) {
      if (value) {
        this.$set(this.form, this.form.medalName, value);
      } else {
        this.$set(this.form, this.form.medalName, null);
      }
      this.$refs.ruleForm.clearValidate("medalName");
      this.form.rules6 =
        value == "无偿献血"
          ? "按献血量"
          : value == "公益捐款" || value == "公益捐赠"
          ? "按捐款/捐物价值"
          : value == "指尖公益"
          ? "按活动"
          : value == "志愿服务" || value == "团体公益时长"
          ? "按时长"
          : "";
      this.form.coefficient = null;
      this.form.duration = null;
      this.$forceUpdate();
    },
    //改变解锁时长
    changeUnlockDuration(value) {
      if (value) {
        this.$set(this.form, this.form.unlockDuration, value);
      } else {
        this.$set(this.form, this.form.unlockDuration, null);
      }
      this.$forceUpdate();
    },
    //改变时长系数
    changeDurationCoefficient(value) {
      if (value) {
        this.$set(this.form, this.form.coefficient, value);
      } else {
        this.$set(this.form, this.form.coefficient, null);
      }
      this.$forceUpdate();
    },

  //改变设定时长
    changeSetDuration(value) {
      if (value) {
        this.$set(this.form, this.form.duration, value);
      } else {
        this.$set(this.form, this.form.duration, null);
      }

      this.$forceUpdate();
    },
    //改变积分
    changePoint(value) {
      if (value) {
        this.$set(this.form, this.form.point, value);
      } else {
        this.$set(this.form, this.form.point, null);
      }
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="scss" scoped>
.content1 {
  background-color: #f2fcf9;
  // height: 100%;
  .query_con {
    // margin: 30px 40px 20px 40px;
    padding: 40px 0 0px 40px;
    // border: 1px solid #e5e5e5;
    border-radius: 5px;
    ::v-deep {
      .el-date-editor .el-range-separator {
        padding: 0 28px;
      }
    }
    .add {
      color: #fff;
      background-color: #23c0d8;
      border-color: #23c0d8;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }
}
.form_hint {
  margin-top: 10px;
  font-size: 20px;
  color: #c9554b;
  line-height: 25px;
}
</style>
